import React from "react";

const items = [
  "Tower portfolios",
  "Dark fiber",
  "Edge compute",
  "Rooftop sites",
  "Small cells",
  "Macro 5G",
  "Data centers",
  "Backhaul",
];

const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-neutral-950 py-6"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display text-2xl font-medium text-neutral-500 sm:text-3xl">
              {t}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-orange-500/60" />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-neutral-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-neutral-950 to-transparent" />
    </div>
  );
};

export default Marquee;
